import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerSubscriptionsComponent } from './customer-subscriptions.component';

const routes: Routes = [{ path: '', component: CustomerSubscriptionsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerSubscriptionsRoutingModule { }
